import gql from "graphql-tag";

export const CREATE_ORGANIZATION = gql`
  mutation AddOrganization($data: OrganizationDataInput) {
    addOrganization(data: $data) {
      id
    }
  }
`;

export const CREATE_ORGANIZATIONS = gql`
  mutation AddOrganizations($data: [OrganizationDataInput]) {
    addOrganizations(data: $data) {
      id
    }
  }
`;

export const CREATE_ENTERPRISE = gql`
  mutation AddEnterprise($data: EnterpriseDataInput) {
    addEnterprise(data: $data) {
      id
    }
  }
`;

export const SET_ENTERPRISE_ACTIVE = gql`
  mutation SetEnterpriseActive(
    $data: EnterpriseActivityDataInput
    $where: OrganizationWhereInput
  ) {
    setEnterpriseActive(where: $where, data: $data) {
      id
      active
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation UpdateOrganization(
    $data: OrganizationDataInput
    $where: OrganizationWhereInput
  ) {
    updateOrganization(where: $where, data: $data) {
      id
    }
  }
`;

export const DELETE_ORGANIZATION = gql`
  mutation DeleteOrganization($where: OrganizationWhereInput) {
    deleteOrganization(where: $where) {
      id
    }
  }
`;

export const IMPORT_ORGANIZATIONS_FROM_FILE = gql`
  mutation ImportOrganizationsFromFile($data: ImportOrganizationsInput) {
    importOrganizationsFromFile(data: $data) {
      id
    }
  }
`;

export const DUPLICATE_ORGANIZATION = gql`
  mutation DuplicateOrganization(
    $where: OrganizationWhereInput
    $data: DuplicateOrganizationDataInput
  ) {
    duplicateOrganization(where: $where, data: $data) {
      id
    }
  }
`;

export const ONBOARD_ORGANIZATION = gql`
  mutation OnboardOrganization($data: OnboardOrganizationInput!) {
    onboardOrganization(data: $data) {
      id
    }
  }
`;

export const LINK_ORGANIZATION_KEY = gql`
  mutation LinkOrganizationKey(
    $where: OrganizationWhereInput!
    $keyArn: String!
    $replace: Boolean
  ) {
    linkOrganizationKey(where: $where, keyArn: $keyArn, replace: $replace) {
      status
      mode
      keyArn
      expiresAt
      activatedAt
      verifiedAt
      importValidTo
      region
      identity
      keyPolicy
      handover {
        email
        expiresAt
        open
      }
    }
  }
`;

export const PREPARE_ORGANIZATION_KEY_IMPORT = gql`
  mutation PrepareOrganizationKeyImport($where: OrganizationWhereInput!) {
    prepareOrganizationKeyImport(where: $where) {
      publicKey
      validTo
    }
  }
`;

export const IMPORT_ORGANIZATION_KEY = gql`
  mutation ImportOrganizationKey(
    $where: OrganizationWhereInput!
    $encryptedKeyMaterial: String!
    $expiresAt: DateTime
    $replace: Boolean
  ) {
    importOrganizationKey(
      where: $where
      encryptedKeyMaterial: $encryptedKeyMaterial
      expiresAt: $expiresAt
      replace: $replace
    ) {
      status
      mode
      keyArn
      expiresAt
      activatedAt
      verifiedAt
      importValidTo
      region
      identity
      keyPolicy
      handover {
        email
        expiresAt
        open
      }
    }
  }
`;

export const VERIFY_ORGANIZATION_KEY = gql`
  mutation VerifyOrganizationKey($where: OrganizationWhereInput!) {
    verifyOrganizationKey(where: $where) {
      status
      mode
      keyArn
      expiresAt
      activatedAt
      verifiedAt
      importValidTo
      region
      identity
      keyPolicy
      handover {
        email
        expiresAt
        open
      }
    }
  }
`;

export const SET_ORGANIZATION_API_ACCESS = gql`
  mutation SetOrganizationApiAccess(
    $where: OrganizationWhereInput!
    $enabled: Boolean!
  ) {
    setOrganizationApiAccess(where: $where, enabled: $enabled) {
      enabled
      issuer
      tokenUrl
      apiUrl
      scope
      credentials {
        id
        createdDate
        label
        method
        userId
        clientId
        keyId
        keyExpiresAt
        allowedIps
        enabled
        usageCount
        lastUsedAt
        pending
        handover {
          email
          expiresAt
          open
        }
      }
    }
  }
`;

export const CREATE_ORGANIZATION_API_CREDENTIAL = gql`
  mutation CreateOrganizationApiCredential(
    $where: OrganizationWhereInput!
    $data: OrganizationApiCredentialDataInput!
    $baseUrl: String
  ) {
    createOrganizationApiCredential(
      where: $where
      data: $data
      baseUrl: $baseUrl
    ) {
      clientSecret
      credential {
        id
        createdDate
        label
        method
        userId
        clientId
        keyId
        keyExpiresAt
        allowedIps
        enabled
        usageCount
        lastUsedAt
        pending
        handover {
          email
          expiresAt
          open
        }
      }
    }
  }
`;

export const DELETE_ORGANIZATION_API_CREDENTIAL = gql`
  mutation DeleteOrganizationApiCredential(
    $where: OrganizationWhereInput!
    $credential: OrganizationApiCredentialWhereInput!
  ) {
    deleteOrganizationApiCredential(where: $where, credential: $credential) {
      enabled
      issuer
      tokenUrl
      apiUrl
      scope
      credentials {
        id
        createdDate
        label
        method
        userId
        clientId
        keyId
        keyExpiresAt
        allowedIps
        enabled
        usageCount
        lastUsedAt
        pending
        handover {
          email
          expiresAt
          open
        }
      }
    }
  }
`;

export const SEND_ORGANIZATION_KEY_HANDOVER = gql`
  mutation SendOrganizationKeyHandover(
    $where: OrganizationWhereInput!
    $recipient: String!
    $baseUrl: String
  ) {
    sendOrganizationKeyHandover(
      where: $where
      recipient: $recipient
      baseUrl: $baseUrl
    ) {
      status
      mode
      keyArn
      expiresAt
      activatedAt
      verifiedAt
      importValidTo
      region
      identity
      keyPolicy
      handover {
        email
        expiresAt
        open
      }
    }
  }
`;

export const RESEND_ORGANIZATION_API_CREDENTIAL = gql`
  mutation ResendOrganizationApiCredential(
    $where: OrganizationWhereInput!
    $credential: OrganizationApiCredentialWhereInput!
    $recipient: String!
    $baseUrl: String
  ) {
    resendOrganizationApiCredential(
      where: $where
      credential: $credential
      recipient: $recipient
      baseUrl: $baseUrl
    ) {
      enabled
      issuer
      tokenUrl
      apiUrl
      scope
      credentials {
        id
        createdDate
        label
        method
        userId
        clientId
        keyId
        keyExpiresAt
        allowedIps
        enabled
        usageCount
        lastUsedAt
        pending
        handover {
          email
          expiresAt
          open
        }
      }
    }
  }
`;

const organizations = {
  CREATE_ORGANIZATION,
  ONBOARD_ORGANIZATION,
  CREATE_ENTERPRISE,
  SET_ENTERPRISE_ACTIVE,
  UPDATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  IMPORT_ORGANIZATIONS_FROM_FILE,
  CREATE_ORGANIZATIONS,
  DUPLICATE_ORGANIZATION,
  LINK_ORGANIZATION_KEY,
  PREPARE_ORGANIZATION_KEY_IMPORT,
  IMPORT_ORGANIZATION_KEY,
  VERIFY_ORGANIZATION_KEY,
  SET_ORGANIZATION_API_ACCESS,
  CREATE_ORGANIZATION_API_CREDENTIAL,
  DELETE_ORGANIZATION_API_CREDENTIAL,
  SEND_ORGANIZATION_KEY_HANDOVER,
  RESEND_ORGANIZATION_API_CREDENTIAL,
};

export default organizations;
